module.exports = {
      id: "magazines-usage",
      viewBox: "0 0 25.36 20.288",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#magazines",
      toString: function () {
        return this.url;
      }
    }